// Page.jsx
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../components/Sidebar";
import TabManager from "../components/TabManager";
import ShortcutHelperModal from "../components/ShortcutHelperModal";
import { FiInfo, FiPlus } from "react-icons/fi";
import {
  getOpenTabsFromLocalStorage,
  setOpenTabs,
} from "../redux/opentab/opentabSlice";
import { create_or_update_opentab_thunk } from "../redux/opentab/opentabThunk";

export default function Page() {
  // const [openTabs, setOpenTabs] = useState([]);
  const token = localStorage.getItem("todoToken");
  const dispatch = useDispatch();
  const openTabs = useSelector((state) => state.opentab.openTabs);
  const [activeTab, setActiveTab] = useState(null);
  const [activeTabData, setActiveTabData] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isShortcutModalOpen, setIsShortcutModalOpen] = useState(false);
  let user = JSON.parse(localStorage.getItem("todoUser"));
  let userId = user?._id;

  // ref
  const sidebarInputRef = useRef(null);
  const tabRenameInputRef = useRef(null);
  const todoInputRef = useRef(null);
  const todoEditInputRef = useRef(null);
  const setShortCutFileRef = useRef(null);

  useEffect(() => {
    dispatch(getOpenTabsFromLocalStorage());
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.altKey || event.metaKey) && event.key === "n") {
        event.preventDefault();
        setIsAddModalOpen(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const openTodo = (data) => {
    if (!openTabs || openTabs?.length === 0) {
      dispatch(setOpenTabs([data]));
      localStorage.setItem("openTabs", JSON.stringify([data]));
      dispatch(
        create_or_update_opentab_thunk({
          data: [data],
          token: token,
        })
      );
      setActiveTab(data.id);
      return;
    }

    // Find if tab exists
    const existingTabIndex = openTabs.findIndex((tab) => tab.id === data.id);

    if (existingTabIndex === -1) {
      // If tab doesn't exist, add it
      dispatch(setOpenTabs([...openTabs, data]));
      localStorage.setItem("openTabs", JSON.stringify([...openTabs, data]));
      dispatch(
        create_or_update_opentab_thunk({
          data: [...openTabs, data],
          token: token,
        })
      );
    } else {
      // If tab exists, update it with new data (for moves)
      // const updatedTabs = [...openTabs];
      // updatedTabs[existingTabIndex] = data;
      // dispatch(setOpenTabs(updatedTabs));
      // localStorage.setItem("openTabs", JSON.stringify(updatedTabs));
      // dispatch(
      //   create_or_update_opentab_thunk({
      //     data: updatedTabs,
      //     token: token,
      //   })
      // );
    }
    setActiveTab(data.id);
  };
  // const openTodo = (data) => {
  //   if (!openTabs || openTabs?.length === 0) {
  //     dispatch(setOpenTabs([data]));
  //     localStorage.setItem("openTabs", JSON.stringify([data]));
  //     dispatch(
  //       create_or_update_opentab_thunk({
  //         data: [data],
  //         token: token,
  //       })
  //     );
  //     setActiveTab(data.id);
  //     return;
  //   }

  //   // console.log("openTabs", openTabs);
  //   // Find if tab exists
  //   const existingTab = openTabs.filter((tab) => tab.id === data.id);
  //   const existingTabIndex = openTabs.findIndex((tab) => tab.id === data.id);

  //   console.log(" openTabs existingTabIndex", existingTab);
  //   console.log(" openTabs existingTabIndex", data);
  //   console.log(
  //     "existingTab?.parentId !== data.parentId",
  //     existingTab?.parentId !== data.parentId
  //   );
  //   console.log("existingTab", existingTab);
  //   if (existingTab === -1 && existingTab?.parentId !== data.parentId) {
  //     // If tab doesn't exist, add it
  //     // console.log("if");
  //     // const updatedTabs = [...openTabs];
  //     // updatedTabs[existingTabIndex] = data;
  //     // dispatch(setOpenTabs(updatedTabs));
  //     // localStorage.setItem("openTabs", JSON.stringify(updatedTabs));
  //     // dispatch(
  //     //   create_or_update_opentab_thunk({
  //     //     data: updatedTabs,
  //     //     token: token,
  //     //   })
  //     // );
  //   } else {
  //     console.log("else");
  //     // If tab exists, update it with new data (for moves)
  //     // dispatch(setOpenTabs([...openTabs, data]));
  //     // localStorage.setItem("openTabs", JSON.stringify([...openTabs, data]));
  //     // dispatch(
  //     //   create_or_update_opentab_thunk({
  //     //     data: [...openTabs, data],
  //     //     token: token,
  //     //   })
  //     // );
  //   }
  //   setActiveTab(data.id);
  // };
  const updateTodoInOpenTabs = (updatedTodo) => {
    const updatedTabs =
      openTabs?.length > 0 &&
      openTabs?.map((tab) =>
        tab.id === updatedTodo.id ? { ...tab, name: updatedTodo.name } : tab
      );

    dispatch(setOpenTabs(updatedTabs));
    dispatch(
      create_or_update_opentab_thunk({
        data: updatedTabs,
        token: token,
      })
    );
  };

  const changeBackgroundColor = (updatedTodo, apicall) => {
    const updatedTabs =
      openTabs?.length > 0 &&
      openTabs?.map((tab) =>
        tab.id === updatedTodo.id
          ? { ...tab, backgroundColor: updatedTodo.backgroundColor }
          : tab
      );

    dispatch(setOpenTabs(updatedTabs));
    if (apicall) {
      dispatch(
        create_or_update_opentab_thunk({
          data: updatedTabs,
          token: token,
        })
      );
    }
  };

  const deleteTodoFromOpenTabs = (todoId) => {
    const updatedTabs =
      openTabs?.length > 0 && openTabs?.filter((tab) => tab.id !== todoId);

    // Update activeTab if the deleted tab was active
    if (activeTab === todoId) {
      const newActiveTab = updatedTabs.length ? updatedTabs[0].id : null;
      setActiveTab(newActiveTab);
    }

    dispatch(setOpenTabs(updatedTabs));
    dispatch(
      create_or_update_opentab_thunk({
        data: updatedTabs,
        token: token,
      })
    );
  };
  return (
    <div className="flex flex-col md:flex-row w-screen h-screen overflow-hidden">
      <div className="z-10 md:z-50">
      <Sidebar
               openTodo={openTodo}
               activeTab={activeTab}
               setActiveTab={setActiveTab}
               changeBackgroundColor={changeBackgroundColor}
               updateTodoInOpenTabs={updateTodoInOpenTabs}
               deleteTodoFromOpenTabs={deleteTodoFromOpenTabs}
               sidebarInputRef={sidebarInputRef}
               todoInputRef={todoInputRef}
               todoEditInputRef={todoEditInputRef}
               tabRenameInputRef={tabRenameInputRef}
               activeTabData={activeTabData}
               setShortCutFileRef={setShortCutFileRef}
               setActiveTabData={setActiveTabData}
             />
      </div>
      <div className="flex-1 overflow-x-hidden overflow-y-auto md:z-10 bg-gray-800">
      <TabManager
            // todos={todos}
            openTabs={openTabs}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            setOpenTabs={setOpenTabs}
            userId={userId}
            closeTodo={(id) => {
              let openTab =
                openTabs?.length > 0 &&
                openTabs?.filter((tab) => tab.id !== id);
              dispatch(setOpenTabs(openTab));
              // Filter the tabs and ensure we always have an array
              const filteredTabs =
                openTabs?.filter((tab) => tab.id !== id) || [];

              // Stringify the array before setting to localStorage
              localStorage.setItem("openTabs", JSON.stringify(filteredTabs));
              dispatch(
                create_or_update_opentab_thunk({
                  data: openTab,
                  token: token,
                })
              );
            }}
            sidebarInputRef={sidebarInputRef}
            todoInputRef={todoInputRef}
            todoEditInputRef={todoEditInputRef}
            tabRenameInputRef={tabRenameInputRef}
            setShortCutFileRef={setShortCutFileRef}
            activeTabData={activeTabData}
            setActiveTabData={setActiveTabData}
          />
        <button
          onClick={() => setIsShortcutModalOpen(true)}
          className="fixed bottom-4 right-4 bg-blue-500 text-white p-3 hidden md:flex rounded-full shadow-lg hover:bg-blue-600 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          aria-label="Show keyboard shortcuts"
        >
          <FiInfo className="w-6 h-6" />
        </button>
      </div>
      <ShortcutHelperModal isOpen={isShortcutModalOpen} onClose={() => setIsShortcutModalOpen(false)} />
    </div>
  )
}
